<template>
  <v-container>
    <Login v-model="loginDialog" ref="logindialog"></Login>
    <Register v-model="registerDialog" ref="registerdialog"></Register>
    <v-app-bar dense class="white" height="60" fixed elevate-on-scroll>
      <v-row align="center" justify="space-around">
        <v-btn
          icon
          @click="toHome()"
          v-show="$vuetify.breakpoint.smAndUp"
          class="ml-5"
          aria-label="home button image"
          ><v-img
            max-width="120"
            width="100%"
            contain
            src="@/assets/frogigo_logo1.png"
          ></v-img
        ></v-btn>

        <v-btn icon @click="toHome()" v-show="$vuetify.breakpoint.xsOnly">
          <v-icon color="secondary">{{mdiHome}}</v-icon>
        </v-btn>

        <v-btn
          icon
          @click="toHomeSection('spot_inquiry')"
          v-show="isShow('self-pick-spot')"
          text
          color="darken1"
          class="font-weight-black"
        >
          {{ $t("label.self_pick_spot") }}
        </v-btn>

        <v-btn
          icon
          @click="toHomeSection('Pricing')"
          v-show="isShow('pricing')"
          text
          color="darken1"
          class="font-weight-black"
        >
          {{ $t("label.pricing") }}
        </v-btn>

        <v-btn
          icon
          @click="toNews"
          text
          color="darken1"
          class="font-weight-black"
        >
          {{ $t("label.news") }}
        </v-btn>
        <!-- v-show="isShow('news')" -->

        <v-btn
          icon
          @click="toFaq"
          text
          color="darken1"
          class="font-weight-black"
        >
          {{ $t("label.faq") }}
        </v-btn>
        <!-- v-show="isShow('faq')" -->

        <v-btn
          icon
          @click="openRegisterDialog"
          v-show="!isLogin() && isShow('register')"
          text
          color="darken1"
          class="font-weight-black"
        >
          {{ $t("label.register") }}
        </v-btn>

        <v-btn
          icon
          @click="openLoginDialog"
          v-show="!isLogin()"
          text
          color="darken1"
          class="font-weight-black"
        >
          <v-icon v-show="$vuetify.breakpoint.smAndUp">{{mdiLogin}}</v-icon>
          {{ $t("label.login") }}
        </v-btn>

        <v-btn
          icon
          @click="toManagement"
          v-show="isLogin()"
          text
          color="darken1"
          class="font-weight-black"
        >
          <v-icon v-show="$vuetify.breakpoint.smAndUp">{{mdiLaptop}}</v-icon>
          {{ $t("label.control_panel") }}
        </v-btn>
        <v-btn
          icon
          @click="localeDialog = true"
          v-show="false"
          text
          color="darken1"
          class="font-weight-black"
        >
          <v-icon v-show="$vuetify.breakpoint.smAndUp">{{mdiEarth}}</v-icon>
          {{ $t("label.lang_current") }}
        </v-btn>
      </v-row>

      <Language v-model="localeDialog"></Language>
    </v-app-bar>
  </v-container>
</template>

<script>
import { SystemLogout } from "@/api/publicServices";
import { mdiHome, mdiEarth, mdiLaptop, mdiLogin } from '@mdi/js'

export default {
  name: "MainMenu",
  props: {
    menuOptions: {
      type: Array,
    },
  },
  data: () => ({
    userType: "",
    localeDialog: false,
    loginDialog: false,
    registerDialog: false,

    //svg icons
    mdiHome,
    mdiEarth,
    mdiLaptop,
    mdiLogin,
  }),
  mounted() {
    if (this.$route.query.Registration != undefined) {
      this.registerDialog=true;
    }
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" }).catch(() => {});
    },
    toNews() {
      this.$router.push({ name: "news" }).catch(() => {});
    },
    toFaq() {
      this.$router.push({ name: "faq" }).catch(() => {});
    },
    toSetting() {},
    async logout() {
      localStorage.removeItem("member_no");
      localStorage.removeItem("access_token");
      try {
        const response = await SystemLogout();
        if (response.data.isSuccess) {
          this.$router.push({ name: "home" }).catch(() => {});
        } else {
          this.$router.push({ name: "home" }).catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$router.push({ name: "home" }).catch(() => {});
      }

      window.location.reload();
    },
    isShow(item) {
      return this.menuOptions.includes(item);
    },
    isLogin() {
      return (
        (localStorage["access_token"] != undefined &&
          localStorage["access_token"] != "") ||
        (localStorage["member_no"] != undefined &&
          localStorage["member_no"] != "")
      );
    },
    toManagement() {
      this.$router.push({ name: "management" }).catch(() => {});
    },
    toHomeSection(section) {
      console.log(section);
      const el = this.$parent.$el.querySelector(`#${section}`);
      if (el) {
        window.location.hash = section;
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        console.log(window.location);
        this.$router.push({ path: `/#${section}`  }).catch(() => {
          this.toSection();
        });
      }
    },
    toSection(section) {
      var element = document.getElementById(section);
      if (element != null) {
        element.scrollIntoView();
      }
    },
    openLoginDialog() {
      console.log("openLoginDialog");
      this.loginDialog = true;
      this.$refs.logindialog.initMemberID();
    },
    openRegisterDialog() {
      console.log("openRegisterDialog");
      this.registerDialog = true;
      this.$refs.registerdialog.resetRegister();
    },
  },
};
</script>

<style scoped>
@media (max-width: 960px) {
  .v-dialog__content {
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
